import { createDisplayFieldPicker } from '@/utils/rowCacheSync';

/** Picks tasks DataGrid display fields from a cached task entry. */
export const pickTaskDisplayFieldsFromCache = createDisplayFieldPicker({
	ownerId: 'truthy',
	ownerDocId: 'truthy',
});
